/**
 * ATS 专题页首屏与品牌图预加载，减少菜单切换时白屏闪烁
 */

/** @type {Record<string, string>} */
const HERO_BY_PATH = {
  '/about-the-savior': require('@/assets/AbouttheSavior/hero_bg_digital_city.png'),
  '/global-rescue': require('@/assets/GlobalRescue/hero_bg_earth_network.png'),
  '/rescue-list': require('@/assets/rescuelist/hero_bg_city_night.png'),
  '/rescuelist': require('@/assets/rescuelist/hero_bg_city_night.png'),
  '/health-monitoring': require('@/assets/healthMonitoring/hm_hero_bg.png'),
  '/first-aid-kit': require('@/assets/firstaidkit/hero_bg_first_aid.png'),
  '/company-intro': require('@/assets/aboutTheGreatSavior/hero_bg_skyscraper_night.png')
}

/** @type {Record<string, string[]>} 各路由首屏关键图（含 hero 叠层素材） */
const CRITICAL_IMAGES_BY_PATH = {
  '/about-the-savior': [
    HERO_BY_PATH['/about-the-savior'],
    require('@/assets/AbouttheSavior/djx-skAndItShallBeGiven.png'),
    require('@/assets/AbouttheSavior/IntelligentCloudPlatform.png'),
    require('@/assets/AbouttheSavior/icon_hero_modular_command.png'),
    require('@/assets/AbouttheSavior/icon_hero_shield_security.png'),
    require('@/assets/AbouttheSavior/icon_hero_emergency_pulse.png'),
    require('@/assets/AbouttheSavior/icon_hero_smart_core_gem.png')
  ],
  '/global-rescue': [HERO_BY_PATH['/global-rescue']],
  '/rescue-list': [HERO_BY_PATH['/rescue-list']],
  '/rescuelist': [HERO_BY_PATH['/rescuelist']],
  '/health-monitoring': [HERO_BY_PATH['/health-monitoring']],
  '/first-aid-kit': [HERO_BY_PATH['/first-aid-kit']],
  '/company-intro': [HERO_BY_PATH['/company-intro']]
}

/** @type {Set<string>} */
const loaded = new Set()

/**
 * @param {string} src
 * @returns {boolean}
 */
export function isImagePreloaded (src) {
  return !!src && loaded.has(src)
}

/**
 * @param {string} src
 * @returns {Promise<void>}
 */
export function preloadImage (src) {
  if (!src || loaded.has(src)) {
    return Promise.resolve()
  }
  return new Promise((resolve) => {
    const img = new Image()
    const finish = () => {
      loaded.add(src)
      resolve()
    }
    const done = () => {
      if (typeof img.decode === 'function') {
        img.decode().then(finish).catch(finish)
        return
      }
      finish()
    }
    img.onload = done
    img.onerror = finish
    img.src = src
    if (img.complete) {
      done()
    }
  })
}

/**
 * @param {string} path
 * @returns {string[]}
 */
function getCriticalUrlsByPath (path) {
  const urls = CRITICAL_IMAGES_BY_PATH[path] || [HERO_BY_PATH[path]]
  return [...new Set(urls.filter(Boolean))]
}

/** @returns {Promise<void>} */
export function preloadAtsBrandLogo () {
  return preloadImage(require('@/assets/logo.png'))
}

/** @returns {Promise<void>} */
export function preloadAllAtsHeroImages () {
  const urls = [...new Set([
    ...Object.values(HERO_BY_PATH),
    ...Object.values(CRITICAL_IMAGES_BY_PATH).flat()
  ])]
  return Promise.all(urls.map(preloadImage)).then(() => {})
}

/**
 * 预加载目标页首屏关键图（hero + 叠层素材）
 * @param {string} path - 路由 path
 * @returns {Promise<void>}
 */
export function preloadAtsPageByPath (path) {
  const urls = getCriticalUrlsByPath(path)
  if (!urls.length) {
    return Promise.resolve()
  }
  return Promise.all(urls.map(preloadImage)).then(() => {})
}

/**
 * @param {string} path - 路由 path
 * @returns {Promise<void>}
 */
export function preloadAtsHeroByPath (path) {
  return preloadAtsPageByPath(path)
}

/**
 * @param {string} path
 * @returns {boolean}
 */
export function isAtsHeroPreloaded (path) {
  const src = HERO_BY_PATH[path]
  return !!src && loaded.has(src)
}



// WEBPACK FOOTER //
// ./src/util/atsImagePreload.js